<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                Журнал событий
            </template>
            <h2>Журнал событий</h2>
            <template #actions>
                <div class="d-flex actions">
                    <button-component kind="tertiary" :class="{filtered: isFiltered}" @click="modals.filter = !modals.filter">
                        <template #prepend>
                            <icon-component class="mr-2" name="filter" />
                        </template>
                        Фильтр
                    </button-component>
                </div>
            </template>
        </page-header>
        <section class="content">
            <template v-if="page.items">
                <template v-if="page.items.length">
                    <div class="table-inner">
                    <table class="table-custom">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Действие</th>
                            <th>Дата и время</th>
                            <th>Критичность</th>
                            <th>Пользователь</th>
                            <th>Категория</th>
                            <th>Тип объекта</th>
                            <th>ID объекта</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item) in page.items" :key="item.id" :class="item.logSeverity.name.toLowerCase()">
                            <td>{{item.id}}</td>
                            <td>
                                <a href="javascript:" @click="showDescription(item)">{{item.permission.name}}</a>
                            </td>
                            <td>{{ $momentFormat(item.created, "DD.MM.YYYY HH:mm:ss") }}</td>
                            <td>{{item.logSeverity.title}}</td>
                            <td>
                                <router-link :to="`/admin/users/view/${item.userId}`">
                                {{item.user?.fullName}} ({{item.user?.userName}})
                                </router-link>
                            </td>
                            <td>{{item.logCategory.title}}</td>
                            <td>
                                <div v-if="item.entityType">
                                    {{item.entityType.title}}
                                </div>
                                <div v-if="item.dictionary">
                                    {{item.dictionary.title}}
                                </div>
                            </td>
                            <td>
                              {{item.itemId}}
                              <template v-if="item.itemComment">
                                <sup class="pr-1"><i class="fa fa-info-circle" 
                                  :title="item.itemComment" 
                                  @click="showDescription2(item.entityType?.title + ': ' + item.itemComment)"></i></sup>
                              </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                    <div v-if="page.pagesTotal > 1">
                        <Pagination
                                :page-count="page.pagesTotal"
                                :current-page="page.pageNumber"
                                @change="onPageChange($event)"
                        />
                    </div>
                    <div>
                      <PageCounter :isFiltered="isFiltered" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
                    </div>
                </template>
                <template v-else>
                    <EmptyListMessage />
                </template>
            </template>
            <section class="modals">
                <transition name="filter">
                    <div class="filter" v-if="modals.filter">
                        <LogFilter
                                v-bind:filters="filters"
                                v-on:apply="onFiltersApply($event)"
                                v-on:reset="onFiltersReset($event)"
                        />
                    </div>
                </transition>
            </section>
        </section>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import IconComponent from "../../../common/ui/IconComponent";
  import EmptyListMessage from "../../../common/components/EmptyListMessage";
  import Constants from "../../../common/constants";
  import LogFilter from "../components/LogFilter";
  import API from "../api/log";
  import filtermanager from "../../../common/mixins/filtermanager";
  import PageCounter from "@/common/components/PageCounter";
  export default {
    name: "Log",
    components: {LogFilter, EmptyListMessage, IconComponent, ButtonComponent, PageHeader, PageCounter},
    mixins: [filtermanager],
    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filters: {
          categoryIds: [],
          severityIds: [],
          dateFrom: null,
          dateTo: null,
          userIds: [],
          permissionIds: [],
          entityTypeIds: [],
          dictionaryIds: []
        },
        page: {},
        modals: {
          filter: false
        },
        isFiltered: false,
        totalCount: 0,
      };
    },
    created() {
      const self = this;
      API.search({pageNumber: 1, pageSize: 1})
        .then((response) => {
          self.totalCount = response.data.itemsTotal;
        });
      this.loadPage();
    },
    methods: {
      loadPage() {
        const filter = this.loadFilter();
        if (filter) {
          this.filters = filter;
          this.isFiltered = true;
        }
        API.search(Object.assign(this.filters, this.request))
            .then((response) => {
              this.page = response.data;
            });
      },
      showDescription(item) {
        Constants.alert.fire('Описание события', item.description || 'Детальное описание события отсутствует.', 'info');
      },
      showDescription2(text) {
        Constants.alert.fire('Описание объекта', text || 'Описание отсутствует.', 'info');
      },
      onFiltersApply(filters) {
        this.filters = filters;
        this.request.pageNumber = 1;
        this.modals.filter = false;
        this.saveFilter(this.filters);
        this.isFiltered = true;
        this.loadPage();
      },
      onFiltersReset(filters) {
        this.filters = filters || {};
        this.request.pageNumber = 1;
        this.modals.filter = false;
        this.removeFilter();
        this.isFiltered = false;
        this.loadPage();
      },
      onPageChange(pageNumber) {
        this.request.pageNumber = pageNumber;
        this.loadPage();
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    .content{
        padding: 16px 16px 0 16px;
        position: relative;
        overflow-y: visible;
        .filter{
            position: absolute;
            width: 350px;
            height: auto;
            top: 0;
            right: 0;
            overflow: hidden;
            background-color: transparent;
            opacity: 1;
            transition: opacity .2s;
        }
        .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }
    }
    .filtered {
        color: $red;
        &:hover {
            color: $red-dark;
        }
    }
</style>
